/* eslint-disable import/prefer-default-export */
import * as React from "react";
import { Heading, ReviewCount } from "@components";
import classNames from "classnames";

import { MergedProduct } from "../../../queries/data/productData";
import { addHeapReviewsBottomlineClicked } from "../../../services/elevar/events";
import selectors from "../selectors";

interface TitleAndReviewProps {
  product: MergedProduct;
  price: string;
  hidePriceOnMobile?: boolean;
}

export function TitleAndReview({
  product,
  price,
  hidePriceOnMobile,
}: TitleAndReviewProps) {
  const handleReviewsClicked = () => {
    addHeapReviewsBottomlineClicked(product.title);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <Heading
          variant="h4"
          as="h1"
          className="!font-serif text-[24px] leading-9"
        >
          {product.title}
        </Heading>
        {product.shouldHidePrice ? null : (
          <p
            className={classNames("font-normal text-charcoal", {
              "hidden lg:block": hidePriceOnMobile,
            })}
          >
            {price}
          </p>
        )}
      </div>
      {product.rating && (
        <a
          href="#reviews"
          onClick={handleReviewsClicked}
          className="pointer-events-auto"
          data-testid={selectors.reviewsLink}
        >
          <ReviewCount
            stars={product.rating.stars}
            reviewCount={product.rating.reviewCount}
          />
        </a>
      )}
    </div>
  );
}
